var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './shortListDate.module.scss';
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { IDENTIFIER_DATETIME_INPUT_SHORTCUT_OPTION_ITEM, IDENTIFIER_DATETIME_INPUT_SHORTCUT_OPTIONS, } from 'src/ui/components/Input/DateTimeInput/constants';
import { getDateIntervalForShortcut } from 'src/ui/components/Input/DateTimeInput/helpers';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var ShortListDate = function (props) {
    var _a;
    var i18n = props.i18n, shortcutDates = props.shortcutDates, currentShortcut = props.currentShortcut, onDateChange = props.onDateChange, onShortcutDateClick = props.onShortcutDateClick;
    var _b = useState({
        visible: false,
    }), currentFocus = _b[0], setCurrentFocus = _b[1];
    var listRef = useRef(null);
    if (!shortcutDates) {
        return null;
    }
    var handleHoverItem = function (e) {
        var _a = e.target.getBoundingClientRect(), y = _a.y, height = _a.height;
        var top = listRef.current.getBoundingClientRect().top;
        setCurrentFocus({ top: y - top, visible: true, height: height });
    };
    var handleHoverLeave = function () {
        setCurrentFocus(function (prev) { return ({ visible: false }); });
    };
    var handleItemClick = function (e, shortcut) {
        e.stopPropagation();
        var dateIntervalShortcut = getDateIntervalForShortcut(shortcut.type);
        onDateChange(dateIntervalShortcut);
        onShortcutDateClick(shortcut);
    };
    var focusSelectorElementClass = classNames(styles.itemFocus, (_a = {},
        _a[styles.itemFocusVisible] = currentFocus.visible,
        _a));
    return (_jsxs("ul", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT_SHORTCUT_OPTIONS, ref: listRef, className: styles.shortListDateWrapper, onMouseLeave: handleHoverLeave }, { children: [_jsx("div", { className: focusSelectorElementClass, style: currentFocus.top !== undefined
                    ? {
                        top: currentFocus.top,
                        height: currentFocus.height,
                    }
                    : null }), shortcutDates.map(function (shortcut) {
                var _a;
                var shortcutLabel = getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, "dateTimeRangeSelectInput.customLabels.".concat(shortcut.labelKey)) ||
                    shortcut.labelKey;
                return (_jsx("li", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT_SHORTCUT_OPTION_ITEM, className: classNames(styles.shortListItem, (_a = {},
                        _a[styles.shortListItemActive] = currentShortcut && currentShortcut.labelKey === shortcut.labelKey,
                        _a)), onMouseMove: handleHoverItem, onClick: function (e) { return handleItemClick(e, shortcut); } }, { children: shortcutLabel }), shortcut.labelKey));
            })] })));
};
